<template>
  <div class="boiler-room-links">
    <div class="header">
      <img src="/assets/sf/icon/boiler.svg" class="title-icon" /><img
        src="/assets/sf/image/logo_pancake-swap.png"
        class="title-icon"
      />Pancakeswap links for boiler
    </div>
    <div class="links">
      <a
        href="https://pancakeswap.finance/swap?inputCurrency=0xfD1dD9F98F5f5625ce243B1E817cbFa0594AbAeA"
        class="item"
        target="_blank"
      >
        <img src="/assets/sf/image/logo_pancake-swap.png" />
        Bolier Stable swap
      </a>
      <a
        href="https://pancakeswap.finance/add/0xfD1dD9F98F5f5625ce243B1E817cbFa0594AbAeA/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56"
        class="item d-icon"
        target="_blank"
      >
        <img src="/assets/sf/icon/boiler.svg" />
        <img src="/assets/sf/icon/busd-s.svg" />
        Get CAKE-LP
      </a>
      <a
        href="https://pancakeswap.finance/add/0xfD1dD9F98F5f5625ce243B1E817cbFa0594AbAeA/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0"
        class="item d-icon"
        target="_blank"
      >
        <img src="/assets/sf/icon/boiler.svg" />
        <img src="/assets/sf/image/icon_grad.png" />
        Get CAKE-LP
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoilerRoomLinks",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
.boiler-room-links {
  margin: 0 auto;
  max-width: 800px;
  background: var(--color_bg_parts);
  border-radius: 12px;
  box-shadow: $box-shadow;
  padding: 32px;
}
.header {
  font-size: 3rem;
  font-weight: 800;
  display: inline-block;
  background: $gradation-vertical;
  background-clip: text;
  color: transparent;
  line-height: 1.5;
  padding-left: 100px;
  position: relative;
  margin-bottom: 40px;
  @include media(sp) {
    font-size: 2.3rem;
  }
  img {
    position: absolute;
    top: 0;
    &:nth-child(1) {
      left: 10px;
      z-index: 1;
      @include media(sp) {
        top: 14px;
        width: 44px;
        height: 44px;
      }
    }
    &:nth-child(2) {
      left: 44px;
      width: 40px;
      height: 40px;
      top: 2px;
      @include media(sp) {
        top: 16px;
        width: 40px;
        height: 40px;
      }
    }
  }
}
.links {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .item {
    color: #fff;
    width: 350px;
    display: block;
    background: $gradation-vertical;
    border-radius: 30px;
    text-align: center;
    line-height: 4.8rem;
    height: 4.8rem;
    position: relative;
    img {
      width: 30px;
      height: 30px;
      vertical-align: text-bottom;
      margin-right: 8px;
    }
    &:nth-child(-n + 2) {
      margin-bottom: 2rem;
    }
    @include media(sp) {
      &:nth-child(-n + 4) {
        margin-bottom: 2rem;
      }
    }
    &.d-icon {
      img {
        z-index: 2;
        &:nth-child(1) {
          margin-left: -32px;
          margin-right: -8px;
        }
        &:nth-child(2) {
          z-index: 1;
          margin-right: 8px;
          @include media(sp) {
            left: 60px;
          }
        }
      }
    }
  }
}
</style>